import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            更新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500">最新片源上线 · 平台公告 · 专题策划</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-6 md:pl-8 border-l-2 border-secondary-200">
            {updateItems.map((item) => (
              <div key={item.id} className="relative pb-8 last:pb-0">
                <div className="absolute -left-[25px] md:-left-[29px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className={`inline-flex text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
                    item.tag === '新片上线' || item.tag === '独家引进' || item.tag === '剧集上线'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '系统公告' || item.tag === '用户福利'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-200 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-relaxed">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}